import React, { Component } from 'react';
import { Tabs, WhiteSpace, Toast } from 'antd-mobile';
import { CommonlyHeadMembers } from '../../common/headnav';
import $ from "jquery";
import * as services from '../../projects/services';
import {DetailItem } from './detailItem';
import './style.less';
const reporttabs = [
    { title: '报告概述', sub: '1' },
    { title: '报告详情', sub: '2' },
];

export default class ReportDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            params: this.props.match.params,
            report: [],
            oid:0,
        }
    }
    componentDidMount() {
        services.GetReportD(this.state.params, '正在查询，请稍后').then(data => {
            if (data.code === 1) {
                this.setState({ report: data });
            } else {
                Toast.offline('查询错误！');
            }
        });
    }
   
    onTabClick = (tab, index) => {
        this.setState({
            oid: index
        });  
        $("html,body").animate({
            scrollTop: 0
        }, 0);      
    }
    render() {
        const { report } = this.state;
        return <div className="report">
            <CommonlyHeadMembers barname="报告详情" />          
            <Tabs tabs={reporttabs}
             tabBarPosition="top"
             useOnPan={true}
             swipeable={true}
             page={this.state.oid}
             onTabClick={(tab, index) => { this.onTabClick(tab, index) }}              
             onChange={(tab, index) => { this.onTabClick(tab, index) }}
                tabBarActiveTextColor={'#32a128'}
                tabBarInactiveTextColor={'#000000'}
            >
                <div style={{ backgroundColor: '#fff', padding: '1.6rem .3rem .5rem .3rem' }}>
                    <table className="reporttable">
                        <tbody>
                            <tr>
                                <th colSpan="4"  >体检人信息</th>

                            </tr>
                            <tr>
                                <td>姓名</td>
                                <td>{report.tjname}</td>
                                <td>体检编号</td>
                                <td>{report.tjbh}</td>
                            </tr>
                            <tr>
                                <td>性别</td>
                                <td>{report.tjsex}</td>
                                <td>年龄</td>
                                <td>{report.tjage}</td>
                            </tr>
                            <tr>
                                <td>体检时间</td>
                                <td>{report.tjdate}</td>
                                <td>体检医生</td>
                                <td>{report.tjdoctor}</td>
                            </tr>
                            <tr>
                                <td>单位名称</td>
                                <td colSpan="3">{report.tjunit}</td>

                            </tr>
                        </tbody>
                    </table>

                    {
                        !!report.tjdate  && !!report.tjdate ?
                            <div>
                                <WhiteSpace size="lg" />
                                {
                                    !!report.tjzs  && !!report.tjjy  ?
                                        <div>
                                            <table className="reporttable">
                                                <tbody>
                                                    <tr>
                                                        <th>检查综述</th>
                                                    </tr>
                                                    <tr>
                                                        <td><p dangerouslySetInnerHTML={{ __html: report.tjzs }} ></p></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <WhiteSpace size="lg" />
                                            <table className="reporttable">
                                                <tbody>
                                                    <tr>
                                                        <th >医生建议</th>
                                                    </tr>
                                                    <tr>
                                                        <td><p dangerouslySetInnerHTML={{ __html: report.tjjy }} ></p></td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                        : <table className="reporttable">
                                            <tbody>
                                                <tr>
                                                    <th  >总结及建议</th>
                                                </tr>
                                                <tr>
                                                    <td><p dangerouslySetInnerHTML={{ __html: report.tjzs }} ></p><p dangerouslySetInnerHTML={{ __html: report.tjjy }} ></p></td>

                                                </tr>

                                            </tbody>
                                        </table>

                                }

                            </div> : <div className="reportTitle">体检报告尚未总检</div>
                    }
                </div>
                <div style={{ backgroundColor: '#fff', padding: '1.6rem .3rem .5rem .3rem' }}>
            
                    {
                        !report.tjjrmx ?
                            <div className="reportTitle">暂时没有详细的项目检查信息</div>
                            :
                            <DetailItem reportd={report} />
                    }
                </div>

            </Tabs>

        </div>

    }
}